import React from 'react';
import {
  Button as PrimeButton,
  ButtonProps as PrimeButtonProps,
} from 'primereact/button';
import 'primereact/button/button.min.css';
import cn from 'classnames';

import classes from './button.module.scss';

type ButtonSizesType = 'medium'; // possible variants: small, large
type ButtonVariantsType = 'primary' | 'secondary' | 'danger' | 'custom';
type ButtonProps = PrimeButtonProps & {
  rootClassName?: string;
  children?: string;
  variant: ButtonVariantsType;
  size: ButtonSizesType;
  onClick?: (e: React.SyntheticEvent) => void;
};

const Button = (props: ButtonProps): JSX.Element => (
  <div
    className={cn(
      classes.root,
      classes[props.variant],
      classes[props.size],
      props.rootClassName
    )}
  >
    <PrimeButton
      id={props.id}
      label={props.label || props.children}
      icon={props.icon}
      iconPos={props.iconPos}
      badge={props.badge}
      badgeClassName={props.badgeClassName}
      tooltip={props.tooltip}
      tooltipOptions={props.tooltipOptions}
      disabled={props.disabled}
      loading={props.loading}
      loadingIcon={props.loadingIcon}
      onClick={props.onClick}
    />
  </div>
);

Button.defaultProps = {
  rootClassName: undefined,
  size: 'medium',
  variant: 'primary',
  label: undefined,
  icon: undefined,
  iconPos: undefined,
  badge: undefined,
  badgeClassName: undefined,
  tooltip: undefined,
  tooltipOptions: undefined,
  disabled: false,
  loading: undefined,
  loadingIcon: undefined,
  onClick: undefined,
};

export { Button, ButtonProps };
